import { FGBoughtTogether } from "@fgtheme/fg-recommendations";

class WIBoughtTogether extends FGBoughtTogether {
  strikethroughEnabled = false;
  /**
   * @type {string | undefined | null}
   */
  strikethroughPrice = null;

  stateChanging = false;
  addedListeners = false;

  constructor() {
    super();
  }

  async connectedCallback() {
    this.strikethroughEnabled = this.dataset.strikethroughEnabled === "true";
    this.strikethroughPrice = this.dataset.strikethroughPrice;

    await super.connectedCallback();

    const isNoShipState = globalThis.FGAvailabilityData.isNoShipState();
    if (isNoShipState) {
      this.querySelector('.fg-bt-container')?.remove();
      this.selectedVariants.clear();
    }

    this.handleStateChanged = this.handleStateChanged.bind(this);
    if (!this.addedListeners) {
      this.addedListeners = true;
      document.addEventListener('fgw_state_change', this.handleStateChanged);
    }
  }

  disconnectedCallback() {
    this.removeListeners();
    this.querySelector('[data-container]')?.remove();
  }

  removeListeners() {
    this.addedListeners = false;
    document.removeEventListener('fgw_state_change', this.handleStateChanged);
  }

  /**
   * 
   * @param {any} event 
   */
  async handleStateChanged(event) {
    // guard against double firing of state change event
    if (this.stateChanging) {
      return;
    }
    this.stateChanging = true;
    this.querySelector('.fg-bt-container')?.remove();
    this.selectedVariants.clear();
    await this.connectedCallback();
    this.stateChanging = false;
  }

  /**
   * 
   * @param {any[]} shopifyRecommendations 
   */
  filterShopifyProductRecommendations(shopifyRecommendations) {
    const fg_wh = globalThis.FGAvailabilityData.getCurrentWarehouse();

    return shopifyRecommendations.filter(item => {
      // No items of type other than "Bottle"
      if (item.type !== 'Bottle') {
        return false;
      }
      // No unavailable items
      if (!item.available) {
        return false;
      }
      // No items with a selling plan
      if (item.selling_plan_groups.length > 0) {
        return false;
      }
      // No items that require a selling plan
      if (item.requires_selling_plan) {
        return false;
      }
      // No items with multiple variants
      if (item.variants.length > 1) {
        return false;
      }
      // No hidden products
      if (item.tags.includes('hidden-product')) {
        return false;
      }
      // No sold out all items
      if (item.tags.includes('sold-out-all')) {
        return false;
      }
      // No sold out items for the current warehouse
      if (item.tags.includes(`sold-out-${fg_wh?.toLowerCase()}`)) {
        return false;
      }
      // No items missing a featured image
      if (!item.featured_image || item.featured_image === '') {
        return false;
      }
      return true;
    });
  }

  getNodesQuery() {
    return `
      query ProductVariantNodes($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
            title
            price {
              amount
            }
            compareAtPrice {
              amount
            }
            product {
              id
              title
              featuredImage {
                altText
                url
              }
              tags
              handle
              metafield_states: metafield(namespace: "drinks_assure", key: "available_states") {
                value
              }
            }
          }
        }
      }
    `;
  }

  /**
   * 
   * @param {import("@fgtheme/fg-recommendations").FGRecoommendationsProductConfig} productConfig 
   * @param {Set<string>} recommendedVariantIds 
   * @returns {string[]}
   */
  prepareVariantDataIds(productConfig, recommendedVariantIds) {
    // Remove the main product variant id if it was included in recommened products.
    const variantIds = [...recommendedVariantIds].filter(id => id !== productConfig.mainProduct.variantId);
    if (!variantIds || variantIds.length === 0) {
      return [];
    }

    // Put the main product variant back at the start of the array so it's the first item to render in the list
    variantIds.unshift(productConfig.mainProduct.variantId);
    return variantIds;
  }

  modifyRecommendations() {
    /**
     * @type {any}
     */
    const firstItem = this.recommendations[0];

    // If the first item in the array (that would be the current PDP product) is not available
    // in the current state, return zero recs thus hiding the block
    if (firstItem?.product.metafield_states && firstItem?.product.metafield_states.value) {
      const currentState = globalThis.FGAvailabilityData.getCurrentState();
      if (!firstItem.product.metafield_states.value.includes(currentState)) {
        this.recommendations = [];
        return;
      }
      const warehouse = globalThis.FGAvailabilityData.getCurrentWarehouse();
      if (firstItem.product.tags.includes(`sold-out-${warehouse?.toLowerCase()}`)) {
        this.recommendations = this.recommendations.filter(rec => rec.id !== firstItem.id);
      }
    }

    const filtered = this.recommendations.filter((/** @type {any} */ item) => {
      if (item.product.metafield_states && item.product.metafield_states.value) {
        const currentState = globalThis.FGAvailabilityData.getCurrentState();
        if (!item.product.metafield_states.value.includes(currentState)) {
          return false;
        }
      }
      return true;
    });

    this.recommendations = filtered.slice(0, this.componentConfig.numberOfRecs + 1);

    this.recommendations.forEach(item => {
      if (item.product.tags && item.product.tags.includes('no-strikethrough')) {
        return;
      }
      if (this.strikethroughEnabled && this.strikethroughPrice) {
        item.price.amount = this.strikethroughPrice;
      }
    })
  }

  getLineItemProperties() {
    return {
      '_fg_widget_id': 'WI-BOUGHT-TOGETHER'
    }
  }
}

if (!customElements.get('wi-bought-together')) {
  customElements.define('wi-bought-together', WIBoughtTogether);
}